<template>
  <div>
    <el-card class="reserve">
      <span class="clearfix">预订信息</span>
      <el-checkbox-group style="text-align: left; margin-top:20px" v-if="gkfsRole == 1 && tripType == 1" :min="1"
        v-model="checkList">
        <el-checkbox :label="item" v-for="item in cxrList" :key="item.personId">{{ item.cxrName ||
          item.empName }}</el-checkbox>
      </el-checkbox-group>
      <el-divider></el-divider>
      <div class="reserve-center">
        <div class="date">
          <p>入离日期</p>
          <el-date-picker style="width: 350px" v-model="defaultDate" disabled value-format="yyyy-MM-dd" clear-icon
            type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
          <span>共{{ nightCount }}晚</span>
        </div>
        <div class="hotel">
          <p>房间数</p>
          <p>{{ roomNum }}间</p>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="bottom-btn">
        <p>支付总价</p>
        <p>￥{{ priceDetail.totalPrice }}</p>
      </div>
    </el-card>
    <el-card class="reserve person">
      <div class="header">
        <div class="header-left">
          <span class="clearfix">入住人信息</span>
          <p>入住需提供英文姓名或者拼音，需和所持证件一致</p>
        </div>
        <div class="header-right">
          <!-- <p v-if="tripType == 2" @click="cxrVisible = !cxrVisible">选择入住人</p> -->
          <p @click="dialogShow = !dialogShow">调整入住方案</p>
        </div>
      </div>
      <div v-if="tripType == 2" style="color: red; text-align: left; margin-top: 10px;">国际订单英文姓名必须使用“/”分隔</div>
      <el-divider></el-divider>
      <div class="center" v-for="(room, index) in rooms" :key="'roomnokey_' + index">
        <div class="center-left">房间{{ index + 1 }}</div>
        <div class="center-right">
          <span v-for="(cItem, cIndex) in room" :key="'roomempkey_' + cIndex">
            <el-input v-model="cItem.engName" :disabled="tripType == 1" style="width: 139px;margin-right: 30px;"
              :placeholder="tripType == 1 ? '暂无入住人' : '请输入英文姓名'"></el-input>
          </span>
        </div>
      </div>
      <el-divider class="main_divider"></el-divider>
    </el-card>
    <!-- 此处现在只支持国内酒店 -->
    <yj-travel-info ref="htCnTravelInfo" v-if="tripType == 1" :orderType="11022" :proType="10910"
      :cxrList="checkList" :clbzMap="htCnQuery" :policy="policy" @getCxrList="getCxrList" @chooseProject="chooseProject"
      @chooseSpgz="getSpgz" @selectReason="getWbReason" @spgzList="getSpgzList"
      :showApplyRule="showApplyRule" :ccsqdNo="htCnCcsqD.ccsqdNo"></yj-travel-info>

    <el-card class="reserve person travel">
      <div class="header">
        <div class="header-left">
          <span class="clearfix">联系信息</span>
        </div>
      </div>
      <div class="contact">
        <div class="travel-div" style="margin-right: 50px">
          <p>联系人姓名</p>
          <el-input v-model="linker.linkMan" placeholder="输入联系人姓名"></el-input>
        </div>
        <div class="travel-div" style="flex: 1">
          <p>联系人电话</p>
          <el-input v-model="linker.linkPhone" placeholder="联系人电话"></el-input>
        </div>
      </div>
      <div class="contact">
        <div class="travel-div" style="margin-right: 50px">
          <p>联系人邮箱</p>
          <el-input v-model="linker.linkEmail" placeholder="输入联系人邮箱"></el-input>
        </div>
      </div>
    </el-card>

    <el-card class="reserve person travel">
      <div class="header">
        <div class="header-left">
          <span class="clearfix">更多需求</span>
        </div>
      </div>
      <div class="contact" style="margin-top: 15px;">
        <el-input type="textarea" v-model="noteToHotel" :rows="4" placeholder="例：有阳台，无烟房，高楼层"></el-input>
      </div>
    </el-card>

    <el-button class="tye-btn" type="primary" @click="submitOrder" :loading="btnLoading">{{ btnLoading ? '加载中' :
      '下一步' }}
    </el-button>
    <roomDrag :dialogShow.sync="dialogShow" @handlerQuery="handlerQuery" />
    <yj-cxr-list :visible="cxrVisible" :maxLength="10" :tripType="tripType" :cxrList="currentCxrList"
      @chooseCxrList="chooseCxrList" @cancleCxrList="closeCxr"></yj-cxr-list>
  </div>
</template>
<script>
import { validateEnglishName } from '../../../hooks/useHotel';
import { isEmptyObject } from '../../../utils/judge';
import mixin from './../../../mixin';
import roomDrag from './roomDrag.vue';
import { Loading } from 'element-ui';
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  mixins: [mixin.ccsqdMixin],
  props: {
    infoObj: {
      type: Object,
      default() {
        return {
          spgzList: [],
        };
      }
    },
  },
  data() {
    return {
      checkList: [],
      disabled: false,
      dialogShow: false,
      cxrVisible: false,
      loadingInstance: '',
      currentCxrList: [],
      btnLoading: false,
      linker: {
        linkEmail: '',
        linkPhone: '',
        linkMan: '',
      },
      isShowTime: true,
      value1: [], //时间
      totalRate: '',
      chargeunit: 1,
      ninghtRooms: [],
      isFreeMeal: 0,
      value: '',
      spgzInfo: { // 审批规则信息
        gzId: '',
        gzmc: '',
        gzdm: '',
      },
      projectInfo: { // 出差项目信息
        projectCode: "", //出差项目代码 ,
        projectId: "", //出差项目id ,
        projectName: "", //项目名称 ,
      },
      costCenterInfo: { // 成本中心信息
        costCenterCode: "", //成本中心代码 ,
        costCenterId: "", //成本中心id ,
        costCenterName: '', //
      },
      intergralObj: null,
      currentP: 0,
      showApplyRule: true,
      noteToHotel: '',
      emailRequire: false,
    }
  },

  components: {
    roomDrag,
  },
  watch: {
    checkList: {
      handler(val) {
        //选中人变化的时候重新编排房间
        console.log(val);
        this.chooseCxrList(val)
      },
      deep: true
    },
  },
  computed: {
    ...mapState({
      htCnQuery: state => state.intHt.htCnQuery,
      htCnParams: state => state.intHt.htCnParams,
      htCnCcsqD: state => state.intHt.htCnCcsqD,
      ccsqdInfo: state => state.common.ccsqdInfo, // 出差申请单信息
      cxrInfo: state => state.intHt.cxrList,
      ysCxrList: state => state.intHt.ysCxrList,
      htCnPolicy: state => state.intHt.htCnPolicy,
      hotelInfo: (state) => state.intHt.hotelInfo,
      wbObj: state => state.intHt.wbObj,
      rooms: state => state.intHt.rooms,
      selectRatePlan: state => state.intHt.selectRatePlan,
      chooseNationByCard: state => state.intHt.chooseNationByCard,
    }),
    ...mapGetters({
      getVipParamterByParNo: 'common/getVipParamterByParNo',
      nightlyRates: 'intHt/nightlyRates',
      priceDetail: 'intHt/getPriceDetail',
      nightCount: 'intHt/nightCount',
      roomEmpMap: 'intHt/roomEmpMap',
    }),
    defaultDate() {
      return [this.htCnParams.checkInDate, this.htCnParams.checkOutDate]
    },
    roomNum() {
      return this.htCnParams.roomNum || 1;
    },
    // 公司信息
    configData() {
      let configData = this.$common.getConfigData();
      return configData
    },
    policy() {
      return this.htCnPolicy?.policy ?? {}
    },
    // 日期最小，和最大值对象
    bookDateRange() {
      // 方法来自于mixins
      let dateRangeObj = this.getBookDateRange(10903, this.htCnQuery.tripType, 30, this.htCnCcsqD.ccsqdId, this.htCnCcsqD.routeId);
      return dateRangeObj
    },
    gkfsRole() {
      return this.htCnQuery.gkfsRole //默认  0不管控 1： 管控  2安差标管控
    },
    // 判断是否有超标
    isWbPromptBool() {
      let ht20043 = this.getVipParamterByParNo(20043, 0),
        isWb = ht20043 == 1 && this.tripType === 1 && this.wbObj.isWeibei,
        policy = this.htCnPolicy.policy || {},
        jdjgbz = policy.jdjgbz ? policy.jdjgbz - 0 : '';
      // 管控方式 超标自付不需要管控审批
      let gkfs; // 差旅标准价
      if (!!policy.gkfs) {
        gkfs = policy.gkfs - 0;
      }
      if (gkfs == 3 || gkfs == 4) {
        return false;
      }
      if (isWb) {
        for (let item of this.nightlyRates) {
          if (jdjgbz && jdjgbz < item.salePrice) {
            return true;
          }
        }
      }
      return false;
    },
    // 酒店是否开启单间夜价格二次匹配差标
    ht20076() {
      let param = this.$common.getVipParamterByParNo(this.$store, 20076, 0)
      return param == 1 && this.tripType == 1;
    },
    fyys() {
      return this.htCnCcsqD.currentRoute.fyys
    },
    tripType() {
      /* 默认当前因公因私*/
      return this.htCnQuery.tripType
    },
    bookStyle() { // 1单订模式  2出差申请单模式
      return this.$common.getBookStyle(this.$store, 10903) || this.$common.getUserInfo().vipCorp.bookStyle
    },
    cxrList() {
      // 出行人数据该为单独处理， 单订与出差单申请单公用一个出行人数据
      if (this.tripType == 2) {
        return this.ysCxrList || []
      } else {
        return this.cxrInfo || [];
      }
    },
  },
  created() {
    this.value1 = [this.infoObj.checkInDate, this.infoObj.checkOutDate] //初始化赋值一下
    let userInfo = this.$common.getUserInfo();
    this.linker.linkMan = userInfo.empInfo.engName
    this.linker.linkPhone = userInfo.empInfo.phoneNumber;
    this.linker.linkEmail = userInfo.empInfo.email;

    this.checkList = this.cxrList;
    // this.gkfsRole == 1 &&
    if (this.tripType == 1) { // 当为因公模式下的出差申请单模式下 直接禁用
      this.disabled = true;
      this.chooseCxrList(this.checkList)
    }
    // 此处增加默认出行人，
    this.currentCxrList = this.cxrList;
  },
  mounted() {
    this.get5467Param();
    console.log('rooms === ', this.rooms);
  },
  methods: {
    ...mapMutations({
      SAVE_NIGHT: 'intHt/SAVE_NIGHT',
      SAVE_DESCRIPTION: 'intHt/SAVE_DESCRIPTION',
      COPY_ROOMS: 'intHt/COPY_ROOMS',
      SET_HTCN_QUERY: 'intHt/SET_HTCN_QUERY', // 保存因共模式下的自定义信息
      SET_HTCN_POLICY: 'intHt/SET_HTCN_POLICY',
      SET_STATE: 'intHt/SET_STATE',
    }),
    // 获取邮箱是否必填参数
    get5467Param() {
      this.$conn.getConn('commu.getVipCorpParameter')({ paramNo: 5467 }, (res) => {
        var data = res.data || {};
        this.emailRequire = data.value1 == 1;
      }, (err) => {
        // this.$message.error(err.tips)
      })
    },
    // 调整入住人
    handlerQuery(list) {
      this.getHtClbz();
    },
    getHtClbz() {
      if (!this.htCnParams.cityId) return;
      let nowDays = this.$moment().format("YYYY-MM-DD")
      let nextDays = this.$moment().add(1, "days").format("YYYY-MM-DD")
      let params = {
        cityId: this.htCnParams.cityId, //城市或者商圈id
        dateStart: this.htCnParams.checkInDate || nowDays, //日期开始时间
        dateEnd: this.htCnParams.checkOutDate || nextDays, // 日期结束时间
        ccsqdId: this.htCnCcsqD.ccsqdId,
        routeId: this.htCnCcsqD.routeId,
        tripType: 1,
        roomEmpMap: this.roomEmpMap,
      }
      let userInfo = this.$common.getUserInfo();
      params.corpId = userInfo.empInfo.corpId;
      this.$conn.getConn('htbook.interHotelTravelPolicyDetail')(params, (res) => {
        let data = res.data || [];
        let policyInfo = !!data.policy ? { policy: data.policy } : { policy: {} };
        this.SET_HTCN_POLICY(policyInfo);
      })
    },
    // 获取审批规则
    getSpgz(info) {
      this.spgzInfo = {
        gzmc: info.gzmc,
        gzdm: info.gzdm,
        gzId: info.gzId,
      }
    },
    // 获取审批规则列表
    getSpgzList(list) {
      this.spgzList = list;
    },
    // 过期违背原因
    getWbReason(obj) {
      let wbObj = {
        ...this.wbObj,
        wbyyItem: obj
      }
      this.SET_STATE({ wbObj })
      this.SET_HTCN_QUERY(obj)
    },
    getCxrList(val) {
      if (val && val.length > 0) {
        this.checkList = val;
      }
    },
    chooseProject(val) {
      //获取项目
      this.projectInfo = {
        projectCode: val.projectCode, //出差项目代码 ,
        projectId: val.projectId, //出差项目id ,
        projectName: val.projectName, //项目名称 ,
      }
    },
    chooseCxrList(cxrList) {
    },
    closeCxr() {
      this.cxrVisible = false
    },
    // 提交订单时 校验参数
    judgeOrderParams() {
      //验证每个房间内是否至少有一名入住人
      for (let i = 0; i < this.rooms.length; i++) {
        let roomItem = this.rooms[i];
        let hasEmp = false;
        for (let c = 0; c < roomItem.length; c++) {
          let emp = roomItem[c];
          //  || (!!emp.empName && emp.empName != '/')
          if ((!!emp.engName && emp.engName != '/')) {
            hasEmp = true;
          } else {
            if ((!emp.engName && !emp.empName) || emp.engName == '/' || emp.empName == '/') {
              this.btnLoading = false;
              this.$confirm(`请检查第【${i + 1}】间，第【${c + 1}】个入住人的英文名字, 维护英文名字之后再进行预订！`, {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'error'
              });
              return false;
            }
          }

          if (!validateEnglishName(emp.engName)) {
            this.btnLoading = false;
            console.log('存在字母及空格外其它字符 ==== ', emp.engName)
            this.$confirm(`请检查第【${i + 1}】间，第【${c + 1}】个入住人的英文名字, 不能存在字母及空格外其它字符！`, {
              confirmButtonText: '确定',
              showCancelButton: false,
              type: 'error'
            });
            return false;
          }
        }

        if (!hasEmp) {
          this.$message.error(`房间${i + 1}至少需填写一名入住人`);
          this.btnLoading = false;
          return false;
        }
      }

      if (!this.linker.linkMan) {
        this.$message.error('联系人姓名不能为空');
        this.btnLoading = false;
        return false;
      }
      if (!this.linker.linkPhone) {
        this.$message.error('联系人手机号不能为空');
        this.btnLoading = false;
        return false;
      }

      if (!this.linker.linkEmail && this.emailRequire && this.tripType == 1) {
        this.$message.error("联系人邮箱不能为空")
        this.btnLoading = false;
        return false;
      }

      // 校验差旅信息
      if (this.tripType == 1) {
        var clzcRule = this.$refs['htCnTravelInfo'] && this.$refs['htCnTravelInfo'].validTravelInfo();
        if (!clzcRule.bool) {
          this.btnLoading = false;
          this.$message.error(clzcRule.msg)
          return false;
        }
      }

      if (!this.noteToHotel && this.noteToHotel.length > 30) {
        showToast('更多需求文字长度不能大于30')
        this.btnLoading = false;
        return false;
      }
      return true;
    },
    getBookTravelInfo() {
      // 因私不需要
      if (this.tripType == 2) {
        return {}
      }
      let weibei = this.wbObj || {};
      let wbyyItem = {};
      if (weibei.isWeibei && weibei.wbyyItem) {
        wbyyItem = weibei.wbyyItem;
      } else {
        weibei = {};
      }
      let travelInfo = {
        ccsqdId: '', // 出差申请单id ,
        ccsqdNo: '', // 出差申请单号 ,
        costCenterCode: '', // 成本中心代码 ,
        costCenterId: '', // 成本中心id ,
        costCenterName: '', // 成本中心名称 ,
        projectCode: this.projectInfo.projectCode || '', // 出差项目代码 ,
        projectId: this.projectInfo.projectId || '', // 出差项目id ,
        projectName: this.projectInfo.projectName || '', // 项目名称 ,
        reasonCode: wbyyItem.reasonCode || '', // 违背原因代码 ,
        reasonDesc: wbyyItem.reasonDesc || '', // 违背原因说明 ,
        routeId: '', // 行程id ,
        violateitem: !!wbyyItem.reasonCode ? (weibei.violateitem || '') : '', // 违背事项说明 ,
        violateitemCode: !!wbyyItem.reasonCode ? (weibei.violateitemCode || '') : '', // 违背事项代码
        gkfs: weibei.gkfs, // 管控方式
      }

      let bs = this.bookStyle;
      if (bs == 2 && this.tripType) {
        travelInfo.ccsqdId = this.htCnCcsqD.ccsqdId || this.htCnCcsqD.id;
        travelInfo.ccsqdNo = this.htCnCcsqD.ccsqdNo;
        travelInfo.routeId = this.htCnCcsqD.routeId;
      }
      return travelInfo;
    },
    getOrderRoom() {
      let orderRooms = [];
      for (let i = 0; i < this.rooms.length; i++) {
        let customers = [];
        const roomItem = this.rooms[i];
        roomItem.forEach(emp => {
          if (!isEmptyObject(emp)) {
            let isBus = this.tripType == 1;
            let costCenterCode = isBus ? (emp.costCenterCode || '') : '';
            let costCenterId = isBus ? (emp.costCenterId || '') : '';
            let costCenterName = isBus ? (emp.costCenterName || '') : '';
            if (!!emp.engName || !!emp.empName) {
              let cusItem = {
                psgName: emp.cxrName || emp.empName || emp.cName || '',
                // age: emp.age || 1,
                customerName: emp.engName || emp.empName || '',
                email: emp.email || '',
                gender: emp.sex || 'M',
                // isAdult: emp.isAdult || '',
                nationality: emp.nation || '',
                empDeptId: emp.empDeptId || emp.deptId || '', // 员工部门id ,
                empId: emp.empId, // 员工id ,
                phone: emp.phoneNumber || '', // 入住人手机
                costCenterCode, // 成本中心代码 ,
                costCenterId, // 成本中心id ,
                costCenterName, // 成本中心名称 ,
                isAdult: true, // 是否是成人
              };
              if (!cusItem.psgName) {
                cusItem.psgName = cusItem.customerName;
              }
              customers.push(cusItem)
            }
          }
        })
        if (customers.length == 0) {
          this.$message.error('每一个房间至少有一个人！');
          return false;
        }
        orderRooms.push({
          roomNum: i + 1,
          guestInfo: customers
        })
      }
      return orderRooms;
    },
    getBookParam() {
      let orderRooms = this.getOrderRoom();
      if (!orderRooms) return;
      let travelInfo = this.getBookTravelInfo();
      let clbzj; //差旅标准价
      //仅当有差旅政策时,显示差旅标准价
      if (this.htCnPolicy && this.htCnPolicy.jdjgbz) {
        clbzj = this.htCnPolicy.jdjgbz;
      }
      let htQuery = this.htCnParams;
      let params = {
        appId: this.spgzInfo.gzId || '', //审批规则id；C端无需传 ,
        clbzj: clbzj, //,差旅标准价,C端无需传
        cityId: htQuery.cityId,
        cityName: htQuery.cityName,
        checkInDate: htQuery.checkInDate || '', //入住日期：yyyy-mm-dd,不能为空 ,
        checkOutDate: htQuery.checkOutDate || '', // 离店日期：yyyy-mm-dd,不能为空 ,
        hotelId: this.hotelInfo.jdid, // 酒店id,不能为空 ,
        concat: {
          email: this.linker.linkEmail || '', // 联系人邮箱 ,
          phone: this.linker.linkPhone || '', //联系手机,不能为空 ,
          name: this.linker.linkMan || '', //联系人,不能为空 ,
        },
        numOfRooms: this.roomNum,
        noteToHotel: this.noteToHotel || '', //给酒店备注 ,
        orderFrom: '10503',
        guestList: orderRooms, //房间信息 ,
        // payment: selectRatePlan.value?.payment, //支付方式：1现付 2预付,不能为空 ,
        ratePlanId: this.selectRatePlan.ratePlanId || '', // 价格计划id,不能为空 ,
        roomId: this.selectRatePlan.roomId || '', //房型id,不能为空 ,
        fyid: this.selectRatePlan.fyid || '',
        travelInfo: travelInfo, //差旅信息,C端无需传 ,
        tripType: this.tripType, // 差旅类型不能为空,1是因公,2是因私.C端固定传2
        totalPrice: this.priceDetail.totalPrice, // 总价
        payment: 2,// 支付方式：1现付 2预付,不能为空 
        clientNationality: this.chooseNationByCard?.nationality || 'CN', // 国籍
      };
      return params;
    },
    submitOrder() {
      if (!this.judgeOrderParams()) return;
      let params = this.getBookParam();
      const loading = this.$loading({
        lock: true,
        text: '下单中，请勿关闭页面...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      loading.$el.style.fontSize = "30px";
      this.loadingInstance = Loading.service(loading);

      this.$conn.getConn('intht.interHtOrderBook')(params, (res) => {
        this.loadingInstance.close();
        this.btnLoading = false
        this.$message({
          type: 'success',
          message: "订单已生成",
        })
        this.$router.push({
          name: 'HtCnOrderDetail',
          query: {
            orderId: res.data.orderId,
            orderType: 11007
          },
        })
      }, (err) => {
        this.btnLoading = false
        this.loadingInstance.close();
        this.$message({
          type: 'error',
          message: err.tips,
        })
      })
    }
  },
}
</script>

<style scoped lang="scss">
.blue {
  color: #1C83ED;
}

.mgt20 {
  margin-top: 20px;
}

.tye-btn {
  width: 100%;
  background: #ff9524;
  font-size: 24px;
  font-family: '微软雅黑';
  font-weight: 600;
  color: #ffffff;
  height: 80px;
  text-align: center;
  line-height: 80px;
  margin-top: 20px;
  margin-bottom: 50px;
  padding: 0;
}

.flex-c {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.reim {
  display: flex;
  margin-top: 30px;
}

/deep/ .el-select .el-input__inner:focus {
  border-color: #c4cddd;
}

.main_divider {
  margin-top: 0px;
}

.ruler {
  color: #b3b3b3;
  font-size: 12px;
  margin-left: 10px;
}

/deep/ .el-card__body {
  display: flex;
  flex-direction: column;
}

.reserve {
  width: 100%;
  // background-color: #fff;
  padding: 10px;
  background-color: #fff;

  .clearfix {
    text-align: left;
    font-size: 20px;
    color: #424242;
    font-weight: bold;
  }

  .reserve-center {
    display: flex;
    flex-direction: column;

    .date {
      display: flex;
      align-items: center;

      p {
        font-size: 14px;
        margin-right: 70px;
      }

      span {
        margin-left: 30px;
        margin-right: 30px;
      }

      .btn {
        width: 120px;
        height: 35px;
        background-color: #006bb9;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
      }
    }

    .hotel {
      display: flex;
      margin-top: 34px;

      p {
        font-size: 14px;
        margin-right: 82px;
      }
    }
  }

  .bottom-btn {
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    p:nth-child(1) {
      color: #808080;
    }

    p:nth-child(2) {
      font-size: 33px;
      color: #ff9524;
    }
  }
}

.person {
  margin-top: 27px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      color: #b3b3b3;
      font-size: 12px;
      margin-left: 10px;
    }

    .header-left {
      display: flex;
      align-items: center;
    }

    .header-right {
      display: flex;
      text-align: right;

      p {
        font-size: 14px;
        color: #006bb9;
      }
    }
  }

  .center {
    display: flex;
    margin-bottom: 20px;

    .center-right {
      margin-left: 82px;
      display: flex;
      align-items: center;

      /deep/ .el-input:nth-child(2) {
        margin-left: 20px;
        margin-right: 20px;
      }
    }
  }
}

.travel {
  .travel-info {
    width: 100%;
    height: 40px;
    background-color: #f2f8ff;
    display: flex;
    align-items: center;
    color: #8f98a9;
    padding-left: 20px;
    margin-top: 30px;
  }

  .contact {
    display: flex;
  }

  .travel-div {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    p {
      color: #748197;
      font-size: 13px;
      margin-bottom: 10px;
    }

    .travel-person {
      display: flex;

      span {
        width: 150px;
        height: 31.99px;
        border-bottom: 1px solid #c4cddd;
        text-align: center;
        box-sizing: border-box;
        line-height: 31.99px;
        font-weight: bold;
      }
    }
  }

  /deep/ .el-input__inner {
    border: 0;
    padding: 0;
    border-radius: 0;
    border-bottom: 1px solid #c4cddd;
    font-size: 15px;
    font-weight: bold;
  }

  /deep/ .el-textarea__inner {
    font-size: 15px;
    font-weight: bold;
    color: #606266;
  }

}
</style>
